import { Input } from "antd";
import React from "react";
import InputMask from "react-input-mask";

const PhoneInput = ({ value, onChange, defaultValue, name }) => {
  return (
    <InputMask
      mask="+1 (999) 999-9999"
      value={value}
      name={name}
      onChange={onChange}
      defaultValue={defaultValue}
      placeholder="Phone Number"
      className="xl:w-full h-5.4 rounded-sm border-none outline outline-boxGrey p-1 !placeholder-grey  focus:!bg-white focus:!border-primaryBlue hover:!border-primaryBlue"
      maskChar=" "
    >
      {(inputProps) => <Input {...inputProps} />}
    </InputMask>
  );
};

export default PhoneInput;
